// This is generated.  Alter it in blockGroups/detailPanes/types/DetailPane.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { actionUtils } = require('@sstdev/lib_metadata-config');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(
    hNode,
    context,
    parentAccessRestrictions,
  ) {
    const { children, namespace, relation, showForAction } = hNode;

    // Use hNode.securityModifier to figure out access restrictions
    const accessRestrictions = actionUtils.getNodeAccessRestrictions(
      hNode,
      context,
      parentAccessRestrictions,
    );
    // If the context role or feature flags does not result in access to this (or sub) component
    // don't include any part of it in the data dictionary.
    if (accessRestrictions.hidden) return [{}, {}];

    // Determine the action type based on showForAction
    // 'new' or 'new_*' -> create action
    // 'edit' or 'edit_*' -> update action
    const forAction = actionUtils.forActionFromShowForAction(showForAction);

    // Create a new context with the forAction set
    // This allows child form elements to know which action they're being rendered for
    // Form elements (ShortText, DropDown, etc.) will add x-forAction to their schemas
    const childContext = forAction
      ? {
          ...context,
          forAction,
          writeAction: forAction,
        }
      : showForAction
        ? {
            ...context,
            writeAction: actionUtils.normalizeAction(showForAction),
          }
        : context;

    // Process children with the updated context
    let [_subDataDictionary = {}, _partialTypeDefinition = {}] =
      children?.reduce(
        ([sdd, ptd], child) => {
          const [_subDataDictionary = {}, _partialTypeDefinition = {}] =
            context.extractFromChild(child, childContext, accessRestrictions);
          return [
            moduleRegistration.mergeSubDataDictionaries(
              sdd,
              _subDataDictionary,
            ),
            moduleRegistration.mergePartialTypeDefinitions(
              ptd,
              _partialTypeDefinition,
              context,
            ),
          ];
        },
        [{}, {}],
      ) ?? [{}, {}];

    // No route hint unless this pane can name a writable relation. A visible
    // read-only pane should still render, but it should not grant POST/PATCH.
    if (!namespace || !relation || !forAction || accessRestrictions.readOnly) {
      return [_subDataDictionary, _partialTypeDefinition];
    }

    const accessContext = actionUtils.buildWriteAccessContextForAction(
      forAction,
      hNode.blockId,
    );
    const routeAccessHints = Object.entries(accessContext).reduce(
      (hints, [method, access]) => {
        if (access?.value) hints[method] = access;
        return hints;
      },
      {},
    );

    if (!Object.keys(routeAccessHints).length) {
      return [_subDataDictionary, _partialTypeDefinition];
    }

    // This shell has no fields. It is only a breadcrumb for route access/OpenAPI:
    // "a visible create/edit pane exists for namespace.relation." Child form
    // blocks still provide the real request/response shape.
    const routeAccessShell = {
      [namespace]: {
        [relation]: Type.Object(
          {},
          {
            title: relation,
            additionalProperties: true,
            'x-accessRestrictions': accessRestrictions,
            'x-accessContext': accessContext,
            'x-routeAccessHints': routeAccessHints,
          },
        ),
      },
    };

    return [
      moduleRegistration.mergeSubDataDictionaries(
        routeAccessShell,
        _subDataDictionary,
      ),
      _partialTypeDefinition,
    ];
  },
};
moduleRegistration.registerHNodeType(
  'detailPanes',
  'DetailPane',
  module.exports,
);
